import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

export interface SupportItem {
  _id: string;
  userId: string;
  description: string;
  title: string;
  createdAt: string;
  updatedAt: string;
  __v?: number;
  status: "PENDING" | "APPROVED";
  userDetails?: {
    email?: string;
    countryCode?: string;
    callingCode?: string;
    phoneNumber?: string;
    firstName?: string;
    lastName?: string;
    image?: string;
  };
}

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const SupportApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getSupport: builder.query<
      CommonResponseType & {
        data: {
          data: SupportItem[];
          total: number;
        };
      },
      {
        from: number;
        size: number;
        search: string;
        status: "PENDING" | "APPROVED";
      }
    >({
      query: ({ from, size, search, status }) => ({
        url:
          `${END_POINTS.getSupport}?from=${from}&size=${size}&status=${status}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getSupportDetail: builder.query<
      CommonResponseType & {
        data: SupportItem;
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getSupport}/${id}`,
        method: "GET",
      }),
    }),
    updateSupport: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.getSupport}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteSupport: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getSupport}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});
export const {
  useLazyGetSupportQuery,
  useLazyGetSupportDetailQuery,
  useDeleteSupportMutation,
  useUpdateSupportMutation
} = SupportApi;
